
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34726',
  depVersions: {
  "documents-public-ui": "static-1.34726",
  "atom": "static-1.5162",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2585",
  "client-types": "static-1.479",
  "cssUtils": "static-1.816",
  "customer-data-filters-ui": "static-1.40094",
  "customer-data-objects": "static-1.7765",
  "customer-data-property-utils": "static-1.8182",
  "documents-lib": "static-1.34731",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.343",
  "FormsCommonComponents": "static-1.86099",
  "FormUrlGenerator": "static-2.4809",
  "foundations-theming-specialty": "static-1.2236",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5679",
  "hs-test-utils": "static-1.8105",
  "hub-http": "static-1.6309",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11869",
  "HubStyleTokens": "static-2.11562",
  "I18n": "static-7.1634",
  "icons": "static-2.651",
  "jasmine-immutable": "static-1.3109",
  "jasmine-runner": "static-1.6549",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7243",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5483",
  "quartz": "static-1.7137",
  "react": "static-7.187",
  "react-dlb": "static-1.80",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16770",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5409",
  "react-virtualized": "static-2.100",
  "reference-resolvers": "static-1.8262",
  "reference-resolvers-lite": "static-1.8186",
  "reporting-data": "static-1.67899",
  "reporting-reports": "static-1.67577",
  "reporting-snowflake": "static-1.56517",
  "reporting-testing-lib": "static-1.9832",
  "reporting-visualizations": "static-1.59975",
  "reselect": "static-2.16",
  "sales-content-partitioning": "static-1.9032",
  "sanitize": "static-1.4564",
  "sanitize-text": "static-1.8232",
  "self-service-api": "static-1.10335",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1833",
  "signup-constants": "static-1.19044",
  "signup-ui-url-generator": "static-2.8143",
  "StyleGuideUI": "static-3.488",
  "superstore": "static-1.4848",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4850",
  "ui-addon-form-validation": "static-1.11077",
  "ui-asset-management-lib": "static-1.11147",
  "ui-images": "static-2.1174",
  "UIComponents": "static-3.8508",
  "usage-tracker": "static-1.7436",
  "usage-tracker-container": "static-1.7426",
  "usage-tracker-core": "static-1.7286",
  "viral-links-lib": "static-1.7156",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9750",
  "foundations-components": "static-1.8101",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.915",
  "quartz-core": "static-1.6356",
  "quick-fetch": "static-1.3983",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4743",
  "ui-addon-i18n": "static-1.11239",
  "ui-addon-upgrades": "static-9.18112",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3466",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3414",
  "quartz-webpack": "static-1.3361",
  "foundations-assets": "static-1.4957",
  "foundations-theming": "static-1.4520",
  "hub-http-shared-msw-handlers": "static-1.10177",
  "hubspotter-http": "static-1.4717",
  "sassPrefix": "static-1.157",
  "conversations-skeleton-state": "static-1.7337",
  "crm-message-bus": "static-1.43210",
  "customer-data-filters-ui-msw-helpers": "static-1.22529",
  "customer-data-objects-ui-components": "static-1.13119",
  "customer-data-reference-ui-components": "static-1.13257",
  "customer-data-ui-utilities": "static-1.9913",
  "events-data-lib": "static-1.318",
  "framework-builder-read-service-client": "static-1.4071",
  "framework-data-schema-quick-fetch": "static-1.6882",
  "framework-data-schema-resolvers": "static-1.6977",
  "inbound-db-meta-service-client": "static-1.3652",
  "inbound-db-properties-service-client": "static-1.3911",
  "multi-account-reference-resolvers": "static-1.1070",
  "onboarding-tours": "static-1.16762",
  "reporting-datasets-permissions-lib": "static-1.13929",
  "ui-addon-teams": "static-1.21666",
  "quartz-auth": "static-1.812",
  "ui-business-units-lib": "static-1.9148",
  "usage-tracker-session-replay": "static-1.5122",
  "ai-components-ui-library": "static-1.9173",
  "ContentUtils": "static-1.68606",
  "customer-data-properties": "static-1.51883",
  "forms-ai-lib": "static-1.4454",
  "forms-utils-lib": "static-1.12743",
  "foundations-components-test-utils": "static-1.5584",
  "react-dnd-compat": "static-1.4702",
  "react-tinymce": "static-1.55473",
  "tinymce-config": "static-2.54599",
  "ui-gdpr-components": "static-1.10438",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3505",
  "HeadJS": "static-2.766",
  "framer-motion": "static-1.73",
  "hs-test-utils-bend-plugin": "static-1.3216",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "hs-locale-management": "static-1.147",
  "ui-fonts": "static-1.824",
  "i18n-data": "static-1.222",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4413",
  "csstype": "static-1.50",
  "quartz-head": "static-1.802",
  "web-vitals": "static-1.7",
  "batch-promise": "static-1.1630",
  "external-options-client-types": "static-1.4199",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.812",
  "frontend-preferences-client": "static-1.8014",
  "graphql": "static-1.83",
  "immer": "static-1.33",
  "persist-promise": "static-1.3787",
  "reporting-client-types": "static-1.2557",
  "apollo-stack-hubspot": "static-3.87",
  "growth-payments-core": "static-1.25637",
  "hubspot-apollo-client": "static-1.4965",
  "foundations-components-legacy": "static-1.1126",
  "merchandise-lib": "static-1.265",
  "quartz-routing": "static-1.567",
  "hs-story-utils": "static-1.9510",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.313",
  "timezone-utils": "static-2.5331",
  "seat-types-lib": "static-1.219",
  "bend-plugin-foundations-components": "static-1.4370",
  "floating-ui": "static-1.57",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.32",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2154",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.841",
  "mobile-manifest-mixins": "static-1.540",
  "module-federation": "static-1.24",
  "quartz-test": "static-1.812",
  "quartz-tracking": "static-1.516",
  "trellis-components": "static-1.2173",
  "bend-plugin-chirp-manifest": "static-1.153",
  "chirp-fetch": "static-1.1975",
  "purchase-motions-components": "static-1.6053",
  "salesImages": "static-1.526",
  "ts-schema": "static-1.4146",
  "bender-build-tools": "static-1.3278",
  "bend-plugin-foundations-theming": "static-1.3003",
  "stylex": "static-1.34",
  "restore-request-side-panel-lib": "static-1.1096",
  "react-immutable-render-mixin": "static-1.9",
  "hs-resources": "static-1.262",
  "pulse": "static-1.683",
  "conditional-properties-service-client": "static-1.3863",
  "crm-pipelines-api-client-types": "static-1.4204",
  "fdsr-migration-layer": "static-1.96",
  "multi-currency-client-types": "static-1.3757",
  "getting-started-shared-tasks": "static-1.18656",
  "growth-data-modal": "static-1.5566",
  "growth-onboarding-confetti": "static-1.3154",
  "growth-onboarding-next-action-utils": "static-1.2178",
  "navigation-components": "static-1.18239",
  "onboarding-tours-client": "static-1.4976",
  "onboarding-tours-utils": "static-1.828",
  "ui-shepherd-react": "static-3.10309",
  "ui-shepherd-tracker": "static-1.7690",
  "ui-universal-auth": "static-1.9080",
  "user-context": "static-1.5197",
  "hubspotter-http-shared-msw-handlers": "static-1.10175",
  "magpie-lib": "static-1.5610",
  "navigation-messaging": "static-1.7566",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.21715",
  "copilot-toolkit": "static-1.11358",
  "cms-field-types": "static-1.4900",
  "content-icons-ui": "static-1.2250",
  "integrations-lib": "static-1.16444",
  "calling-global-api": "static-1.64815",
  "calling-internal-common": "static-1.31395",
  "calling-lifecycle-internal": "static-1.66197",
  "calling-lifecycle-messages": "static-1.58491",
  "commerce-products-lib": "static-1.9865",
  "crm-links": "static-1.6394",
  "customer-data-properties-shared-msw-handlers": "static-1.9504",
  "file-manager-components": "static-1.23841",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4287",
  "meetings-icalendar-utils-lib": "static-1.721",
  "object-builder-ui-client": "static-1.49051",
  "pipeline-validation-client-types": "static-1.4032",
  "property-value-citations": "static-1.2497",
  "smart-property-lib": "static-1.7624",
  "tiered-pricing": "static-1.1408",
  "zustand": "static-1.74",
  "ui-addon-iframeable": "static-1.9150",
  "final-form": "static-1.71",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19975",
  "tinymce-themes": "static-1.56569",
  "data-token-picker": "static-1.16556",
  "hub-http-contrib": "static-1.3129",
  "interframe": "static-3.4847",
  "tinymce-data": "static-1.40684",
  "tinymce-plugins": "static-1.57713",
  "ui-addon-sales-email": "static-1.5298",
  "onboarding-scopes": "static-1.6549",
  "ui-addon-opt": "static-4.8448",
  "apollo-link-hub-http": "static-2.4740",
  "hubspot-apollo-cache": "static-1.424",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.260",
  "base-ui": "static-1.12",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1027",
  "tanstack-virtual": "static-1.31",
  "purchase-motions-api": "static-1.6056",
  "event-emitter": "static-1.1036",
  "bend-plugin-pulse": "static-1.186",
  "fast-json-patch": "static-1.64",
  "onboarding-data-sync-lib": "static-1.2110",
  "growth-onboarding-next-action-components": "static-1.2206",
  "user-context-client": "static-1.4678",
  "idb-keyval": "static-1.45",
  "magpie-types": "static-1.5070",
  "nest": "static-1.319",
  "reactive-lib": "static-1.813",
  "simple-logging-lib": "static-1.3138",
  "unified-auth-core-lib": "static-1.876",
  "getting-started-shared-tasks-store": "static-1.17774",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1003",
  "integrations-error-boundary-lib": "static-1.13859",
  "integrations-tracking-lib": "static-1.5694",
  "native-integrations-shared-strings": "static-1.7869",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10451",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.594",
  "calling-error-reporting": "static-1.31402",
  "shared-worker-versioning": "static-1.11123",
  "calling-usage-tracker": "static-1.6630",
  "voice-sms-access-library": "static-1.1327",
  "customer-data-tracking": "static-1.6977",
  "commerce-permissions": "static-1.863",
  "products-iframe-lib": "static-1.8166",
  "products-ui-components-shared-msw-handlers": "static-1.10559",
  "location-customization-utils-lib": "static-1.9517",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4242",
  "video-components-external": "static-1.11564",
  "video-data-lib": "static-1.35222",
  "data-agent-kit": "static-1.332",
  "feedback-loader": "static-1.29455",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10260",
  "fsm": "static-1.3817",
  "policy-lib": "static-1.6867",
  "react-colorpicker": "static-2.10296",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10323",
  "FileManagerLib": "static-1.39481",
  "NamespacedHubStyle": "static-2.9124",
  "FileManagerCore": "static-1.39340",
  "codemirror": "static-5.96",
  "content-assistance-lib": "static-1.7889",
  "layout-dnd-components": "static-1.12607",
  "layout-dnd-utils": "static-1.11582",
  "react-codemirror": "static-1.10715",
  "ui-addon-emoji-picker": "static-1.9975",
  "ui-brand-identity-lib": "static-1.15587",
  "InboxConnectUtils": "static-4.15039",
  "meetings-connect-utils-lib": "static-1.7692",
  "breeze-engine-core": "static-1.281",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "universal-page-editor-lib": "static-1.3105",
  "ads-unified-auth-lib": "static-1.249",
  "google-sheets-integration-lib": "static-1.498",
  "microsoft-drive-integration-lib": "static-1.636",
  "slack-ui-library": "static-1.10480",
  "calling-orchestration-schema": "static-1.36104",
  "sales-views-client-types": "static-1.4346",
  "crm-record-cards-service-types": "static-1.3656",
  "content-media-composition-data-lib": "static-1.12600",
  "content-media-compositions": "static-2.16607",
  "media-bridge-lib": "static-1.19073",
  "trellis-story-utils": "static-1.4600",
  "storybook-react": "static-1.34",
  "audio-components": "static-1.6047",
  "FileManagerImages": "static-1.36992",
  "video-components": "static-1.13566",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4624",
  "video-embed": "static-1.36056",
  "diff-match-patch": "static-1.7",
  "ui-addon-video-player": "static-1.8791",
  "ui-coaching-tips": "static-1.28806",
  "ContentData": "static-1.68681",
  "layout-data-lib": "static-1.9907",
  "browser-eslint": "static-2.57",
  "social-insights-client-types": "static-1.22298",
  "outpost": "static-1.4259",
  "growth-onboarding-feedback-components": "static-1.6667",
  "advanced-menus-core": "static-1.15267",
  "advanced-menus-lib": "static-1.12184",
  "ExportDialog": "static-6.10470",
  "ui-memberships-settings-lib": "static-1.34282",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15266",
  "simple-menus-lib": "static-1.16783"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34726",
  "atom": "/atom/static-1.5162",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2585",
  "client-types": "/client-types/static-1.479",
  "cssUtils": "/cssUtils/static-1.816",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40094",
  "customer-data-objects": "/customer-data-objects/static-1.7765",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8182",
  "documents-lib": "/documents-lib/static-1.34731",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.343",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86099",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4809",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2236",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5679",
  "hs-test-utils": "/hs-test-utils/static-1.8105",
  "hub-http": "/hub-http/static-1.6309",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11869",
  "HubStyleTokens": "/HubStyleTokens/static-2.11562",
  "I18n": "/I18n/static-7.1634",
  "icons": "/icons/static-2.651",
  "jasmine-immutable": "/jasmine-immutable/static-1.3109",
  "jasmine-runner": "/jasmine-runner/static-1.6549",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7243",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5483",
  "quartz": "/quartz/static-1.7137",
  "react": "/react/static-7.187",
  "react-dlb": "/react-dlb/static-1.80",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16770",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5409",
  "react-virtualized": "/react-virtualized/static-2.100",
  "reference-resolvers": "/reference-resolvers/static-1.8262",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8186",
  "reporting-data": "/reporting-data/static-1.67899",
  "reporting-reports": "/reporting-reports/static-1.67577",
  "reporting-snowflake": "/reporting-snowflake/static-1.56517",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9832",
  "reporting-visualizations": "/reporting-visualizations/static-1.59975",
  "reselect": "/reselect/static-2.16",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9032",
  "sanitize": "/sanitize/static-1.4564",
  "sanitize-text": "/sanitize-text/static-1.8232",
  "self-service-api": "/self-service-api/static-1.10335",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1833",
  "signup-constants": "/signup-constants/static-1.19044",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8143",
  "StyleGuideUI": "/StyleGuideUI/static-3.488",
  "superstore": "/superstore/static-1.4848",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4850",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11077",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11147",
  "ui-images": "/ui-images/static-2.1174",
  "UIComponents": "/UIComponents/static-3.8508",
  "usage-tracker": "/usage-tracker/static-1.7436",
  "usage-tracker-container": "/usage-tracker-container/static-1.7426",
  "usage-tracker-core": "/usage-tracker-core/static-1.7286",
  "viral-links-lib": "/viral-links-lib/static-1.7156",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9750",
  "foundations-components": "/foundations-components/static-1.8101",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.915",
  "quartz-core": "/quartz-core/static-1.6356",
  "quick-fetch": "/quick-fetch/static-1.3983",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4743",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11239",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18112",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3466",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3414",
  "quartz-webpack": "/quartz-webpack/static-1.3361",
  "foundations-assets": "/foundations-assets/static-1.4957",
  "foundations-theming": "/foundations-theming/static-1.4520",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10177",
  "hubspotter-http": "/hubspotter-http/static-1.4717",
  "sassPrefix": "/sassPrefix/static-1.157",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7337",
  "crm-message-bus": "/crm-message-bus/static-1.43210",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22529",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13119",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13257",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9913",
  "events-data-lib": "/events-data-lib/static-1.318",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4071",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6882",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6977",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3652",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3911",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1070",
  "onboarding-tours": "/onboarding-tours/static-1.16762",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13929",
  "ui-addon-teams": "/ui-addon-teams/static-1.21666",
  "quartz-auth": "/quartz-auth/static-1.812",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9148",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5122",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9173",
  "ContentUtils": "/ContentUtils/static-1.68606",
  "customer-data-properties": "/customer-data-properties/static-1.51883",
  "forms-ai-lib": "/forms-ai-lib/static-1.4454",
  "forms-utils-lib": "/forms-utils-lib/static-1.12743",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5584",
  "react-dnd-compat": "/react-dnd-compat/static-1.4702",
  "react-tinymce": "/react-tinymce/static-1.55473",
  "tinymce-config": "/tinymce-config/static-2.54599",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10438",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3505",
  "HeadJS": "/HeadJS/static-2.766",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3216",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "hs-locale-management": "/hs-locale-management/static-1.147",
  "ui-fonts": "/ui-fonts/static-1.824",
  "i18n-data": "/i18n-data/static-1.222",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4413",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.802",
  "web-vitals": "/web-vitals/static-1.7",
  "batch-promise": "/batch-promise/static-1.1630",
  "external-options-client-types": "/external-options-client-types/static-1.4199",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.812",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8014",
  "graphql": "/graphql/static-1.83",
  "immer": "/immer/static-1.33",
  "persist-promise": "/persist-promise/static-1.3787",
  "reporting-client-types": "/reporting-client-types/static-1.2557",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.87",
  "growth-payments-core": "/growth-payments-core/static-1.25637",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4965",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1126",
  "merchandise-lib": "/merchandise-lib/static-1.265",
  "quartz-routing": "/quartz-routing/static-1.567",
  "hs-story-utils": "/hs-story-utils/static-1.9510",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.313",
  "timezone-utils": "/timezone-utils/static-2.5331",
  "seat-types-lib": "/seat-types-lib/static-1.219",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4370",
  "floating-ui": "/floating-ui/static-1.57",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.32",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2154",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.841",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.540",
  "module-federation": "/module-federation/static-1.24",
  "quartz-test": "/quartz-test/static-1.812",
  "quartz-tracking": "/quartz-tracking/static-1.516",
  "trellis-components": "/trellis-components/static-1.2173",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.153",
  "chirp-fetch": "/chirp-fetch/static-1.1975",
  "purchase-motions-components": "/purchase-motions-components/static-1.6053",
  "salesImages": "/salesImages/static-1.526",
  "ts-schema": "/ts-schema/static-1.4146",
  "bender-build-tools": "/bender-build-tools/static-1.3278",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3003",
  "stylex": "/stylex/static-1.34",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1096",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hs-resources": "/hs-resources/static-1.262",
  "pulse": "/pulse/static-1.683",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3863",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4204",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.96",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3757",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18656",
  "growth-data-modal": "/growth-data-modal/static-1.5566",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3154",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2178",
  "navigation-components": "/navigation-components/static-1.18239",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4976",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.828",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10309",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7690",
  "ui-universal-auth": "/ui-universal-auth/static-1.9080",
  "user-context": "/user-context/static-1.5197",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10175",
  "magpie-lib": "/magpie-lib/static-1.5610",
  "navigation-messaging": "/navigation-messaging/static-1.7566",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.21715",
  "copilot-toolkit": "/copilot-toolkit/static-1.11358",
  "cms-field-types": "/cms-field-types/static-1.4900",
  "content-icons-ui": "/content-icons-ui/static-1.2250",
  "integrations-lib": "/integrations-lib/static-1.16444",
  "calling-global-api": "/calling-global-api/static-1.64815",
  "calling-internal-common": "/calling-internal-common/static-1.31395",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66197",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58491",
  "commerce-products-lib": "/commerce-products-lib/static-1.9865",
  "crm-links": "/crm-links/static-1.6394",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9504",
  "file-manager-components": "/file-manager-components/static-1.23841",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4287",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.721",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49051",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4032",
  "property-value-citations": "/property-value-citations/static-1.2497",
  "smart-property-lib": "/smart-property-lib/static-1.7624",
  "tiered-pricing": "/tiered-pricing/static-1.1408",
  "zustand": "/zustand/static-1.74",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9150",
  "final-form": "/final-form/static-1.71",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19975",
  "tinymce-themes": "/tinymce-themes/static-1.56569",
  "data-token-picker": "/data-token-picker/static-1.16556",
  "hub-http-contrib": "/hub-http-contrib/static-1.3129",
  "interframe": "/interframe/static-3.4847",
  "tinymce-data": "/tinymce-data/static-1.40684",
  "tinymce-plugins": "/tinymce-plugins/static-1.57713",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5298",
  "onboarding-scopes": "/onboarding-scopes/static-1.6549",
  "ui-addon-opt": "/ui-addon-opt/static-4.8448",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4740",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.424",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.260",
  "base-ui": "/base-ui/static-1.12",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1027",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "purchase-motions-api": "/purchase-motions-api/static-1.6056",
  "event-emitter": "/event-emitter/static-1.1036",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.186",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2110",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2206",
  "user-context-client": "/user-context-client/static-1.4678",
  "idb-keyval": "/idb-keyval/static-1.45",
  "magpie-types": "/magpie-types/static-1.5070",
  "nest": "/nest/static-1.319",
  "reactive-lib": "/reactive-lib/static-1.813",
  "simple-logging-lib": "/simple-logging-lib/static-1.3138",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.876",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17774",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1003",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13859",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5694",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7869",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10451",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.594",
  "calling-error-reporting": "/calling-error-reporting/static-1.31402",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11123",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6630",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1327",
  "customer-data-tracking": "/customer-data-tracking/static-1.6977",
  "commerce-permissions": "/commerce-permissions/static-1.863",
  "products-iframe-lib": "/products-iframe-lib/static-1.8166",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10559",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9517",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4242",
  "video-components-external": "/video-components-external/static-1.11564",
  "video-data-lib": "/video-data-lib/static-1.35222",
  "data-agent-kit": "/data-agent-kit/static-1.332",
  "feedback-loader": "/feedback-loader/static-1.29455",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10260",
  "fsm": "/fsm/static-1.3817",
  "policy-lib": "/policy-lib/static-1.6867",
  "react-colorpicker": "/react-colorpicker/static-2.10296",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10323",
  "FileManagerLib": "/FileManagerLib/static-1.39481",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9124",
  "FileManagerCore": "/FileManagerCore/static-1.39340",
  "codemirror": "/codemirror/static-5.96",
  "content-assistance-lib": "/content-assistance-lib/static-1.7889",
  "layout-dnd-components": "/layout-dnd-components/static-1.12607",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11582",
  "react-codemirror": "/react-codemirror/static-1.10715",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9975",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15587",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15039",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7692",
  "breeze-engine-core": "/breeze-engine-core/static-1.281",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3105",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.249",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.498",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.636",
  "slack-ui-library": "/slack-ui-library/static-1.10480",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36104",
  "sales-views-client-types": "/sales-views-client-types/static-1.4346",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3656",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12600",
  "content-media-compositions": "/content-media-compositions/static-2.16607",
  "media-bridge-lib": "/media-bridge-lib/static-1.19073",
  "trellis-story-utils": "/trellis-story-utils/static-1.4600",
  "storybook-react": "/storybook-react/static-1.34",
  "audio-components": "/audio-components/static-1.6047",
  "FileManagerImages": "/FileManagerImages/static-1.36992",
  "video-components": "/video-components/static-1.13566",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4624",
  "video-embed": "/video-embed/static-1.36056",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8791",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28806",
  "ContentData": "/ContentData/static-1.68681",
  "layout-data-lib": "/layout-data-lib/static-1.9907",
  "browser-eslint": "/browser-eslint/static-2.57",
  "social-insights-client-types": "/social-insights-client-types/static-1.22298",
  "outpost": "/outpost/static-1.4259",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6667",
  "advanced-menus-core": "/advanced-menus-core/static-1.15267",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12184",
  "ExportDialog": "/ExportDialog/static-6.10470",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34282",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15266",
  "simple-menus-lib": "/simple-menus-lib/static-1.16783"
}
};
